import React from 'react';
import { H6 } from 'scy/text';
import margin from 'scy/margin.mod.scss';

export default function Subheading({ children, tag = 'h2' }) {
  return (
    <H6
      uppercase
      tag={tag}
      marginClass={`${margin.top_md} ${margin.bottom_sm}`}
    >
      {children}
    </H6>
  );
}
